module.exports = __webpack_public_path__ + "img/icb-del-Inte-e@3x.610cfe0d.png";